import Common from "../../../Common";
import Item from "./ringgroup/Item";

const RingGroup = class extends Common {
	item: InstanceType<typeof Item>;

	constructor(headers: ApiHeaders) {
		super(headers)
		this.item = new Item(headers);
	}

	browse = (companyId: id) =>
		this.get(`/company/${companyId}/pbx/ringgroup`);

	browseAll = (companyId: id) =>
		this.get(`/company/${companyId}/pbx/ringgroup/all`);

	read = (companyId: id, id: id) =>
		this.get(`/company/${companyId}/pbx/ringgroup/${id}`);

	create = (companyId: id, data: any, options?: DadExtraOptions) =>
		this.post(`/company/${companyId}/pbx/ringgroup${options?.skipRedraw ? '?skipRedraw=1' : ''}`, data);

	update = (companyId: id, id: id, data: any, options?: DadExtraOptions) =>
		this.patch(`/company/${companyId}/pbx/ringgroup/${id}${options?.skipRedraw ? '?skipRedraw=1' : ''}`, data);

	delete = (companyId: id, id: id) =>
		this.doDelete(`/company/${companyId}/pbx/ringgroup/${id}`);
}

export default RingGroup
